module.exports = __webpack_public_path__ + "img/20_bohle.ae641127.jpeg";